export const formFields={
  	signUp: {
		nickname: {
			order: 1,
			isRequired: true,
			placeholder: 'Enter your nickname'
		},
		username: {
			order: 2,
			placeholder: 'Enter your email',
			label: 'Email'
		},
		password: {
			order: 3,
			placeholder: 'Create password'
		},
		confirm_password: {
			order: 4,
			placeholder: 'Confirm password'  
		}
    }
}